import { EventEmitter } from '@angular/core';
import { AfterContentInit, Output } from '@angular/core';
import { Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { HorizontalListCustomTemplateDirective } from './horizontal-list-custom-template.directive';
import { HorizontalListData, HorizontalListOptionType, HorizontalListItemType, HorizontalListItemSize, HorizontalListOptionData } from './horizontal-list.model';

@Component({
    selector: 'ifc-horizontal-list',
    templateUrl: './horizontal-list.component.html',
    styleUrls: ['./horizontal-list.component.scss'],
    standalone: false
})
export class HorizontalListComponent implements AfterContentInit {
  @Input() items: HorizontalListData[] = [];
  @Output() actionClicked = new EventEmitter<string>();

  readonly OptionType = HorizontalListOptionType;
  readonly ItemType = HorizontalListItemType;
  readonly ItemSize = HorizontalListItemSize;

  @ContentChildren(HorizontalListCustomTemplateDirective)
  private customTemplates: QueryList<HorizontalListCustomTemplateDirective>;

  templateMap: Record<string, TemplateRef<any>> = {};

  constructor(private readonly router: Router) {}

  ngAfterContentInit(): void {
    this.customTemplates?.forEach(tpl => {
      this.templateMap[tpl.name] = tpl.templateRef;
    });
  }

  onClickRouterLink(optionData: HorizontalListOptionData): void {
    if (optionData?.routerLink) {
      this.router.navigateByUrl(optionData.routerLink);
      return;
    }
    if (optionData?.actionName) {
      this.actionClicked.emit(optionData.actionName)
    }
  }

  onClickExternalLink(optionData: HorizontalListOptionData): void {
    if (optionData?.externalLink) {
      window.open(optionData.externalLink, "_blank");
      return;
    }
    if (optionData?.actionName) {
      this.actionClicked.emit(optionData.actionName)
    }
  }
}
